<template>
  <div class="box-voice">
    <div class="voice-header m-b-10">
      <div>
        <v-icon>fa-image</v-icon>
        <span class="m-l-5">Image</span>
      </div>
      <div>
        <v-icon small class="m-l-5" @click="deletePrompt">
          fa-times-circle
        </v-icon>
      </div>
    </div>

    <div class="container">
      <div class="box-type">
        <v-radio-group v-model="prompt.urlType" row hide-details>
          <v-radio
            v-for="(type, indexType) in urlTypes"
            :key="indexType"
            :label="type"
            :value="type"
          >
          </v-radio>
        </v-radio-group>
      </div>
      <div v-if="prompt.urlType === urlTypes[0]">
        <v-autocomplete
          class="m-t-5 no-drag"
          v-model="prompt.path"
          :items="items"
          item-text="allText"
          item-value="path"
          dense
          hide-details
        >
          <template slot="selection" slot-scope="{ item }">
            {{ subString(item.path, 70) }}
          </template>
          <template slot="item" slot-scope="{ item }">
            <v-tooltip top :open-delay="700">
              <template v-slot:activator="{ on, attrs }">
                <div
                  v-bind="attrs"
                  v-on="on"
                  class="float-right width100 font-size-sub margin8px m-r-5"
                >
                  <div class="dropdown-text">
                    {{ subString(item.description, 70) }}
                  </div>
                  <div class="dropdown-title">
                    {{ subString(item.name, 50) }}
                  </div>
                </div>
              </template>
              <span class="font-size-body">
                {{ item.path }}<br />{{ item.description }}
              </span>
            </v-tooltip>
          </template>
        </v-autocomplete>
        <div v-if="description" class="box-description">
          {{ description }}
        </div>
      </div>
      <div v-if="prompt.urlType === urlTypes[1]">
        <v-text-field
          v-model="prompt.url"
          placeholder="Enter image url"
          hide-details
          class="m-t-5"
        ></v-text-field>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'PayloadImageUrl',
  props: {
    index: Number,
    prompt: Object,
    minioHost: String,
    items: Array
  },
  data() {
    return {
      description: '',
      name: '',
      urlTypes: ['Internal', 'External']
    }
  },
  watch: {
    prompt: {
      deep: true,
      immediate: true,
      handler(val) {
        if (this.prompt.path) {
          const item = _.find(this.items, { path: this.prompt.path })
          this.description = item ? item.description : ''
          this.name = item ? item.name : ''
        } else {
          this.description = ''
          this.name = ''
        }
      }
    }
  },
  methods: {
    subString(text, length) {
      if (text.length < length) return text
      return `${text.substr(0, length)}...`
    },
    deletePrompt() {
      this.$emit('deletePrompt', this.index)
    }
  }
}
</script>

<style scoped lang="scss">
.font-size-body {
  max-width: 300px;
  display: flex;
  text-align: justify;
  text-justify: inter-word;
  padding-left: 4px;
  margin-left: 4px;
  padding-right: 4px;
  margin-right: 4px;
  margin-bottom: 0px;
  word-wrap: break-word;
}

.width20px {
  min-width: 20px;
}

.top-5 {
  margin-top: 5px;
  padding: 5px 10px 10px 10px;
  background: white;
}

.dropdown-title {
  font-size: 14px;
}

.dropdown-text {
  font-size: 11px;
  color: $text-color;
}

.margin8px {
  margin: 8px 0;
}

.box-voice {
  background-color: #f7f7f7;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ebebeb;
}

.box-description {
  margin-top: 15px;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #cccccc;
}

.voice-header {
  display: flex;
  justify-content: space-between;
}

.container {
  padding: 10px;
  background-color: #fff;
  border: 1px solid #ebebeb;
  border-radius: 5px;
}

.box-type {
  margin-bottom: 10px;
}
</style>
